import React, { useState, useEffect, useRef } from 'react'
import {
    get_schemes,
    get_departments,
    get_schemes_by_fy,
    get_financial_year,
    getAllocateBudgetList,
    getActivity,
    getSubActivity,
    approve_allocate_budget,
    get_departmentDetail
} from '../../../helper/Api';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AddBudgetPreview from '../Model/AddBudgetPreview';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import './ViewAllocateBudget.css';
import Spinner from '../../Tools/spinner';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import { openAllocateBudgetDocument } from '../../../helper/secureDocuments';
const ViewBudget = () => {
    const [loading, setLoading] = useState(true);
    const pendingLoads = useRef(0);
    const startLoad = () => {
        pendingLoads.current += 1;
        setLoading(true);
    };
    const finishLoad = () => {
        pendingLoads.current -= 1;
        if (pendingLoads.current <= 0) {
            pendingLoads.current = 0;
            setLoading(false);
        }
    };
    const navigate = useNavigate();
    const { viewId, approveId } = useParams();
    const [showPreview, setShowPreview] = useState(false);
    const [fy_list, set_fy_list] = useState([]);
    const [schemeList, setSchemesList] = useState([]);
    const [activity, setActivity] = useState([]);
    const [subActivity, setSubActivity] = useState([]);
    const [scheme, setScheme] = useState({});
    const [subHead, setSubHead] = useState([]);
    const [allocatesubHead, setallocateSubHead] = useState([]);
    const [department, setDepartment] = useState([]);
    const { authData } = useSelector((state) => state.authData);
    const subheadBudgetTotal = useRef({
        allocateProvision: 0,
        allocateRelease: 0,
    });
    const [expandedIndex, setExpandedIndex] = React.useState(null);
    const [formData, setFormData] = useState({
        id: "",
        budget_order_no: "",
        budget_order_date: "",
        provision: 0,
        release: 0,
        scheme_id: null,
        financial_year_id: null,
        supporting_attachment: [],
        order_attachment: [],
        l1_remark: "",
        l2_remark: "",
        l3_remark: "",
        l2_status: "",
        l3_status: "",
        total_scheme_provisional_allocation: 0,
        total_scheme_released_allocation: 0,
        subheads: [],
        department_Array: [
            {
                department_id: "",
                department_level: "",
                department_name: "",
                subHead: [{
                    subhead_id: "",
                    name: "",
                    code: "",
                    provisional_budget: 0,
                    release_budget: 0,
                    balance: 0,
                    approveBudget: 0,
                    santioned: 0,
                    release_Balance: 0,
                    release_Balance: 0,
                    utilised_budget: 0,
                    activity: [{
                        activity_id: '', subactivity_id: '', provisional_budget: "",
                        budget: "",
                    }],
                    activities: [],
                }],
            }],
        parent_department_id: authData.user.department_id,
        budget_order_doc_url: "",
        budget_supporting_doc_url: "",
    });
    const fetchFinancialYears = async () => {
        const fy = await get_financial_year();
        if (fy.data.status) {
            set_fy_list(fy.data.list)
        }
    }
    useEffect(() => {
        fetchActivity();
        fetchSubActivity();
        fetchSchemes({});
        fetchFinancialYears();
        fetchAllocateBudget();
    }, [viewId])
    const fetchSchemes = async () => {
        try {
            startLoad();
            const resp = await get_schemes({ approved: true });
            if (resp.data.status) {
                setSchemesList(resp.data.schemes);
            }
        } catch (error) {
            setSchemesList([]);
        } finally {
            finishLoad();
        }

    }

    const fetchAllocateBudget = async () => {
        try {
            startLoad();
            let subheadArray = [];
            let newDepartmentLevel = authData.user.department_details.department_level;
            if (newDepartmentLevel === "T1") {
                newDepartmentLevel = "T2";
            } else if (newDepartmentLevel === "T2") {
                newDepartmentLevel = "T3";
            } else if (newDepartmentLevel === "T3") {
                newDepartmentLevel = "T4";
            }
            
                const { data } = await getAllocateBudgetList({ id: viewId });
                const departments = await get_departments({ parent_department_id: data.result[0].parent_department_id });
                setDepartment(departments.data.result);
                let totalProvisionalBudgetOverall = 0;
                let totalReleaseBudgetOverall = 0;
                let department_Array = [];

                const resp = await get_schemes_by_fy(data.result[0].scheme_id, data.result[0].financial_year_id);

                const parent_departmentDetails = await get_departmentDetail({ id: data.result[0].parent_department_id });

                if (resp.data.status) {
                    if (resp.data.schemes.length != 0) {
                        resp.data.schemes[0]['departmentName'] = parent_departmentDetails.data.result[0].name;
                        setScheme(resp.data.schemes[0]);
                        setSubHead(resp.data.schemes[0].sub_heads_list);
                        subheadArray = resp.data.schemes[0].sub_heads_list;
                    }
                }
         
                data.result[0].budget_details.forEach((item, itemIndex) => {
                    let departmentObj = departments.data.result.find(d => d.id === item.department_id);
                    let departmentCheck = department_Array.find(d => d.department_id === item.department_id);
                    if (!departmentCheck) {
                        departmentCheck = {
                            department_id: item?.department_id,
                            department_level: departmentObj?.department_level,
                            department_name: departmentObj?.name,
                            subHead: []
                        };
                        department_Array.push(departmentCheck);
                    }
                    let totalProvisionalBudget=0;
                    let totalReleaseBudget=0;
                    let Subheadactivities = [];
                    const subheadActivity = subheadArray.find(d => d.id === item.subhead_id);
                    if (resp.data.schemes[0].monitoring_level && resp.data.schemes[0].monitoring_level !="2") {
                        Subheadactivities = item.activities.map(activity => {
                            const subheadItems = subheadActivity.activities.find(d => d.subhead_activity_id === activity.subhead_activity_id && d.subhead_subactivity_id === activity.subhead_subactivity_id);
                            totalProvisionalBudget += parseFloat(activity.provisional_budget);
                            totalReleaseBudget += parseFloat(activity.budget);
                            return {
                                activity_id: activity.subhead_activity_id,
                                subactivity_id: activity.subhead_subactivity_id,
                                provisional_budget: activity.provisional_budget,
                                budget: activity.budget,
                                subhead_provisional_budget: subheadItems?.provisional_budget | 0,
                                subhead_budget: subheadItems?.budget | 0,
                            };
                        });
                    }
                    else {
                        Subheadactivities = [];
                        totalProvisionalBudget += parseFloat(item.provisional_budget);
                        totalReleaseBudget += parseFloat(item.budget);
                    }
                    const subHead = {
                        id: item.id,
                        subhead_id: item.subhead_id,
                        name: subheadActivity.name,
                        code: subheadActivity.code,
                        provisional_budget: subheadActivity.provisional_budget,
                        budget: subheadActivity.budget | 0,
                        under_approval: subheadActivity?.under_approval | 0,
                        approveBudget: subheadActivity?.approveBudget | 0,
                        utilised_budget: subheadActivity?.utilised_budget | 0,
                        santioned: subheadActivity?.santioned | 0,
                        release_Balance: subheadActivity?.release_Balance | 0,
                        balance: subheadActivity.balance,
                        allocate_provision: totalProvisionalBudget,
                        allocate_release: totalReleaseBudget,
                        activity: Subheadactivities,
                        activities: item.activities,
                        allocated_budget_id: item.allocated_budget_id,
                    };
                    departmentCheck.subHead.push(subHead);
                    totalProvisionalBudgetOverall += parseFloat(totalProvisionalBudget);
                    totalReleaseBudgetOverall += parseFloat(totalReleaseBudget);
                });
                setallocateSubHead(data.result[0].budget_details);
                setFormData({
                    id: data.result[0].id,
                    budget_order_no: data.result[0].budget_order_no,
                    budget_order_date: data.result[0].budget_order_date,
                    scheme_id: data.result[0].scheme_id,
                    financial_year_id: data.result[0].financial_year_id,
                    supporting_attachment: [],
                    order_attachment: [],
                    provision: data.result[0]?.total_scheme_provisional_allocation,
                    release: data.result[0]?.total_scheme_released_allocation,
                    l1_remark: data.result[0].l1_remark,
                    l2_remark: data.result[0].l2_remark,
                    l3_remark: data.result[0].l3_remark,
                    l2_status: data.result[0].l2_status,
                    l3_status: data.result[0].l3_status,
                    total_scheme_provisional_allocation: data.result[0].total_scheme_provisional_allocation,
                    total_scheme_released_allocation: data.result[0].total_scheme_provisional_allocation,
                    subheads: [],
                    budget_order_doc_url: data.result[0].budget_order_doc_url,
                    budget_supporting_doc_url: data.result[0].budget_supporting_doc_url,
                    department_Array: department_Array,
                })
                subheadBudgetTotal.current = {
                    allocateProvision: totalProvisionalBudgetOverall,
                    allocateRelease: totalReleaseBudgetOverall
                };
        } catch (error) {
            toast.error(error?.message || 'Failed to fetch allocate budget details.', {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            finishLoad();
        }
    }
    const fetchActivity = async () => {
        try {
            startLoad();
            const resp = await getActivity();
            if (resp.data.status) {
                setActivity(resp.data.result);
            }
        } catch (error) {
            setActivity([]);
        } finally {
            finishLoad();
        }
    }
    const fetchSubActivity = async () => {
        try {
            startLoad();
            const resp = await getSubActivity();
            if (resp.data.status) {
                setSubActivity(resp.data.result);
            }
        } catch (error) {
            setSubActivity([]);
        } finally {
            finishLoad();
        }
    }
    const findSubActivitiesById = (id) => {
        let listData = subActivity;
        return listData.filter(subActivity => subActivity.activity_id === id);
    };
    const handleSubmit = async (status) => {
        try {
            // anand sir please write code of approve case
            let payload = {
                l2_remark: formData.l2_remark,
                l3_remark: formData.l3_remark,
                l2_status: formData.l2_status,
                l3_status: formData.l3_status
            };
            if (authData.user.user_type.toLowerCase() == 'l2') {
                payload.l2_status = status
            }
            if (authData.user.user_type.toLowerCase() == 'l3') {
                payload.l3_status = status
            }

            const response = await approve_allocate_budget(payload, formData.id);
            if (response.data.status) {
                // rajat please add close popup code and show success or error message
                setShowPreview(false);
                navigate('/allocate-budgets');
            }
        } catch (error) {
            console.log(error);
        }
    }
    const previewhandler = (e) => {
        e.preventDefault();
        setShowPreview(true);
    };
    const handleFormData = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData({
            ...formData,
            [name]: value,
        });
        console.log(formData);
    }
    // Function to toggle the collapse state
    const toggleCollapse = (index) => {
        // If the clicked index is already expanded, collapse it, otherwise set it as the expanded index
        setExpandedIndex(expandedIndex === index ? null : index);
    };


    const getProvisionAndRelease = (array, subhead_id) => {
        let totalProvisionalBudget = 0;
        let totalReleaseBudget = 0;
        let total_provision = 0;
        let total_release = 0;
        array.forEach(item => {
            if (subhead_id) {
                if (item.subhead_id === subhead_id) {
                    totalProvisionalBudget += parseFloat(item.provisional_budget);
                    totalReleaseBudget += parseFloat(item.budget);
                }
            }
            else {
                total_provision += parseFloat(item.provisional_budget);
                total_release += parseFloat(item.budget);
            }
        });
        return { totalProvisionalBudget, totalReleaseBudget, total_provision, total_release };
    }
    const selectedSchemeCode = schemeList.find((option) => String(option?.id) === String(formData.scheme_id))?.code || '';
    const selectedYear = fy_list.find((fy) => String(fy.id) === String(formData.financial_year_id))?.year || '';
    const departmentCode = (departmentId) => department.find((option) => String(option.id) === String(departmentId))?.code || '';
    const activityLabel = (activityId) => activity.find((item) => String(item.id) === String(activityId))?.activity || '';
    const subactivityLabel = (activityId, subactivityId) => (
        findSubActivitiesById(activityId).find((item) => String(item.id) === String(subactivityId))?.subactivity || ''
    );
    const canAct = (authData.user.user_type == 'l2' && formData.l2_status == null)
        || (authData.user.user_type == 'l3' && formData.l3_status == null);
    const alreadyApproved = (formData.l2_status == 1 && authData.user.user_type == 'l2')
        || (formData.l3_status == 1 && authData.user.user_type == 'l3');
    const alreadyRejected = (formData.l2_status == 0 && authData.user.user_type == 'l2')
        || (formData.l3_status == 0 && authData.user.user_type == 'l3');

    return (
        <>
        {loading && <div > <Spinner/> </div>}
            <AddBudgetPreview showPreview={showPreview} setShowPreview={setShowPreview} formData={formData}
                handleSubmit={handleSubmit} scheme={scheme} subheadsList={subHead} financialYears={fy_list}
                department={department} activity={activity} subActivity={subActivity} subheadBudgetTotal={subheadBudgetTotal} pageType={'View'} authData={authData} />
            <div className="view-allocate-budget">
                <div className="view-allocate-budget__header">
                    <h4 className="view-allocate-budget__title">View Allocate Budget</h4>
                    <CustomBreadcrumbs linksArray={[]} title="View Allocate Budget" />
                </div>
                <div className="view-allocate-budget__card">
                    <div className="view-allocate-budget__body view-allocate-budget__meta">
                        <div>
                            <div className="view-allocate-budget__label">Scheme Code</div>
                            <div className="view-allocate-budget__value view-allocate-budget__chip">{selectedSchemeCode || 'Scheme Code'}</div>
                        </div>
                        <div>
                            <div className="view-allocate-budget__label">Financial Year</div>
                            <div className="view-allocate-budget__value view-allocate-budget__chip">{selectedYear || 'Financial Year'}</div>
                        </div>
                    </div>
                </div>
                {formData.scheme_id && formData.financial_year_id && <>
                    <section className="view-allocate-budget__card">
                        <div className="view-allocate-budget__section">Budget Order Details</div>
                        <div className="view-allocate-budget__body view-allocate-budget__grid">
                            <div>
                                <div className="view-allocate-budget__label">Budget Order Ref No</div>
                                <div className="view-allocate-budget__value">{formData.budget_order_no}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Budget Order Date</div>
                                <div className="view-allocate-budget__value">{formData.budget_order_date}</div>
                            </div>
                            <div className="view-allocate-budget__span-2 view-allocate-budget__docs">
                                {formData?.budget_order_doc_url != null && formData?.budget_order_doc_url && (
                                    <button type="button" className="view-allocate-budget__doc-btn" onClick={() => openAllocateBudgetDocument(formData?.id, 'budget_order_doc_url', formData?.budget_order_doc_url)}>Order Attachment</button>
                                )}
                                {formData?.budget_supporting_doc_url != null && formData?.budget_supporting_doc_url ? (
                                    <button type="button" className="view-allocate-budget__doc-btn" onClick={() => openAllocateBudgetDocument(formData?.id, 'budget_supporting_doc_url', formData?.budget_supporting_doc_url)}>supporting_attachment</button>
                                ) : (
                                    <p className="view-allocate-budget__empty-doc">No Supporting Doc Attached</p>
                                )}
                            </div>
                        </div>
                    </section>

                    <section className="view-allocate-budget__card">
                        <div className="view-allocate-budget__section">Scheme Details</div>
                        <div className="view-allocate-budget__body view-allocate-budget__grid">
                            <div>
                                <div className="view-allocate-budget__label">Financial Year</div>
                                <div className="view-allocate-budget__value">{selectedYear}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Department Name</div>
                                <div className="view-allocate-budget__value">{scheme.departmentName}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Scheme Code</div>
                                <div className="view-allocate-budget__value">{scheme.code}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Scheme Name</div>
                                <div className="view-allocate-budget__value">{scheme.name}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Type of Scheme</div>
                                <div className="view-allocate-budget__value">{scheme.type}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Total Provisioned Allocation</div>
                                <div className="view-allocate-budget__value">{subheadBudgetTotal.current.allocateProvision || 0}</div>
                            </div>
                            <div>
                                <div className="view-allocate-budget__label">Total Released Allocation</div>
                                <div className="view-allocate-budget__value">{subheadBudgetTotal.current.allocateRelease || 0}</div>
                            </div>
                        </div>
                    </section>

                    <section className="view-allocate-budget__card">
                        <div className="view-allocate-budget__section">Subhead Details</div>
                        <div className="view-allocate-budget__table-wrap">
                            <table className="view-allocate-budget__table">
                                <thead>
                                    <tr>
                                        <th>Subhead Code</th>
                                        <th>Subhead Name</th>
                                        <th className="view-allocate-budget__amount">Provisional Allocation</th>
                                        <th className="view-allocate-budget__amount">Released Allocation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subHead.map((subhead, index) => {
                                        const isMatchingSubhead = allocatesubHead.find(s => s.subhead_id === subhead.id);
                                        if (!isMatchingSubhead) return null;
                                        return (
                                            <tr key={index}>
                                                <td>{subhead.code}</td>
                                                <td>{subhead.name}</td>
                                                <td className="view-allocate-budget__amount">{getProvisionAndRelease(allocatesubHead, subhead.id).totalProvisionalBudget}</td>
                                                <td className="view-allocate-budget__amount">{getProvisionAndRelease(allocatesubHead, subhead.id).totalReleaseBudget}</td>
                                            </tr>
                                        );
                                    })}
                                    <tr className="view-allocate-budget__total">
                                        <th></th>
                                        <th>Total Allocation</th>
                                        <td className="view-allocate-budget__amount">{getProvisionAndRelease(allocatesubHead,).total_provision}</td>
                                        <td className="view-allocate-budget__amount">{getProvisionAndRelease(allocatesubHead,).total_release}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section className="view-allocate-budget__card">
                        <div className="view-allocate-budget__section">Allocation Details</div>
                        {formData.department_Array.map((item, index) => (
                            <div className="view-allocate-budget__dept" key={index}>
                                <div className="view-allocate-budget__grid">
                                    <div>
                                        <div className="view-allocate-budget__label">Level</div>
                                        <div className="view-allocate-budget__value">{item.department_level}</div>
                                    </div>
                                    <div>
                                        <div className="view-allocate-budget__label">Department Code</div>
                                        <div className="view-allocate-budget__value view-allocate-budget__chip">{departmentCode(item.department_id)}</div>
                                    </div>
                                    <div className="view-allocate-budget__span-2">
                                        <div className="view-allocate-budget__label">Department Name</div>
                                        <div className="view-allocate-budget__value">{item.department_name}</div>
                                    </div>
                                </div>
                                <div className="view-allocate-budget__table-wrap">
                                    <table className="view-allocate-budget__table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <button type="button" className="view-allocate-budget__expand" onClick={() => toggleCollapse(index)} aria-label={expandedIndex === index ? 'Collapse allocation' : 'Expand allocation'}>
                                                        {expandedIndex === index ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                    </button>
                                                    Subhead Code
                                                </th>
                                                <th>Activity</th>
                                                <th>Sub-Activity</th>
                                                <th className="view-allocate-budget__amount">Provisioned Allocation</th>
                                                <th className="view-allocate-budget__amount">Released Allocation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {expandedIndex === index && item.subHead.map((subhead, i) => (
                                                <React.Fragment key={i}>
                                                    {subhead.activities.map((activityData, j) => (
                                                        <tr key={j}>
                                                            <td>{subhead.code}</td>
                                                            <td>{activityLabel(activityData.subhead_activity_id)}</td>
                                                            <td>{subactivityLabel(activityData.subhead_activity_id, activityData.subhead_subactivity_id)}</td>
                                                            <td className="view-allocate-budget__amount">{activityData.provisional_budget | 0}</td>
                                                            <td className="view-allocate-budget__amount">{activityData.budget | 0}</td>
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                            {item.subHead.map((subhead, i) => (
                                                <tr className="view-allocate-budget__total" key={`total-${i}`}>
                                                    <th>{subhead.code}</th>
                                                    <th></th>
                                                    <th>Total Allocation</th>
                                                    <td className="view-allocate-budget__amount">{subhead.allocate_provision}</td>
                                                    <td className="view-allocate-budget__amount">{subhead.allocate_release}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </section>

                    <section className="view-allocate-budget__card">
                        <div className="view-allocate-budget__body view-allocate-budget__remarks">
                            <div>
                                <div className="view-allocate-budget__label">L1 Remark</div>
                                <textarea id="remarl1" className="view-allocate-budget__textarea" rows="2" name="l1_remark" value={formData.l1_remark} disabled={true}></textarea>
                            </div>
                            {(authData.user.user_type == 'l2' || authData.user.user_type == 'l3') && (
                                <div>
                                    <div className="view-allocate-budget__label">L2 Remark *</div>
                                    <textarea id="remarl2" className="view-allocate-budget__textarea" rows="2" name="l2_remark" value={formData.l2_remark} onChange={handleFormData}></textarea>
                                </div>
                            )}
                            {authData.user.user_type == 'l3' && (
                                <div>
                                    <div className="view-allocate-budget__label">L3 Remark *</div>
                                    <textarea id="remarl3" className="view-allocate-budget__textarea" rows="2" name="l3_remark" value={formData.l3_remark}></textarea>
                                </div>
                            )}
                        </div>
                    </section>

                    {canAct ? (
                        <div className="view-allocate-budget__actions">
                            <button type="button" className="view-allocate-budget__btn view-allocate-budget__btn-reject" onClick={previewhandler}>Reject</button>
                            <button type="button" className="view-allocate-budget__btn view-allocate-budget__btn-approve" onClick={previewhandler}>Approve</button>
                        </div>
                    ) : null}
                    <div className="view-allocate-budget__actions">
                        {alreadyApproved && <button type="button" className="view-allocate-budget__btn view-allocate-budget__btn-approve" disabled={true}>Already Approved</button>}
                        {alreadyRejected && <button type="button" className="view-allocate-budget__btn view-allocate-budget__btn-reject" disabled={true}>Already Rejected</button>}
                    </div>
                </>}
            </div>
        </>
    );
}
export default ViewBudget
